import { useRouter } from 'next/router'
import styled from 'styled-components'
import ExamContainedButton from '@app.feature/exam/components/Button/ExamContainedButton'
import PredictionButton from '@app.feature/exam/gsat2024-2/components/button/PredictionButton.desktop'
import GraphIcon from 'svgIcons/GraphIcon'
import TentativeScoringDetailInfoDesktop from './TentativeScoringDetailInfo.desktop'

interface TentativeScoringResultInfoDesktopProps {
  onChangeStage: () => void
}

const TentativeScoringResultInfoDesktop = ({
  onChangeStage,
}: TentativeScoringResultInfoDesktopProps) => {
  const router = useRouter()
  const isGsat2024Route = router.pathname === '/prediction/gsat2024-2'

  const handleChangeStage = () => {
    onChangeStage()
  }

  return (
    <StyledWrapper>
      <TentativeScoringDetailInfoDesktop />
      {isGsat2024Route ? (
        <PredictionButton
          className="get-data-button"
          type="button"
          onClick={handleChangeStage}
        >
          석차분석 및 합격예측 리포트 받아보기
        </PredictionButton>
      ) : (
        <ExamContainedButton
          className="get-data-button"
          type="button"
          onClick={handleChangeStage}
          isEndIcon={false}
        >
          <i>
            <GraphIcon />
          </i>
          석차분석 및 합격예측 리포트 받아보기
        </ExamContainedButton>
      )}
    </StyledWrapper>
  )
}

export default TentativeScoringResultInfoDesktop

const StyledWrapper = styled.div`
  width: 820px;
  padding: 48px;
  border-radius: 20px;
  border: solid 1px #e8e8e8;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 40px;

  .get-data-button {
    width: 100%;

    i {
      margin-right: 10px;
    }
  }
`
